import CompanyModel from '@/models/Base/Company';
import { errorFunc } from '@/utils/errorFunc';
import * as types from './mutation-types';

export const getCompany = ({ commit, dispatch }, payload) => {
  dispatch('wait/start', 'global loading', { root: true });
  return CompanyModel.find(payload)
    .then((response) => {
      commit(types.COMPANY_FETCHED, response);
    })
    .catch(response => errorFunc(response, commit));
};

export const updateCompany = ({ commit, dispatch }, payload) => {
  dispatch('wait/start', 'global loading', { root: true });
  return (new CompanyModel(payload)).save()
    .then((response) => {
      commit(types.COMPANY_FETCHED, response.company);
    })
    .catch(response => errorFunc(response, commit));
};

export const updateVersion = ({ commit }, payload) => {
  commit(types.UPDATE_VERSION, payload);
};

export default {
  getCompany,
  updateCompany,
  updateVersion,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/actions.js